import moment from 'moment';
import * as C from 'handsontable/i18n/constants';
import { registerCondition } from './../../conditionRegisterer';

export const CONDITION_NAME = 'date_yesterday';

export function condition(dataRow) {
  const date = moment(dataRow.value, dataRow.meta.dateFormat);

  if (!date.isValid()) {
    return false;
  }

  return date.isSame(moment().subtract(1, 'days').startOf('day'), 'd');
}

registerCondition(CONDITION_NAME, condition, {
  name: C.FILTERS_CONDITIONS_YESTERDAY,
  inputsCount: 0
});



// WEBPACK FOOTER //
// ./src/plugins/filters/condition/date/yesterday.js